import { UserResponse } from "./UserReponse";
import * as moment from 'moment';
export interface ICustomer {
    customerId: number;
    customerName?: string | undefined;
    isCustomerEnabled?: boolean | undefined;
    totalActiveUsers?: number | undefined;
    lastSearchedOn?: Date | undefined;
    trialEndDate?: Date | undefined;
    createdDate?: Date | undefined;
    createdUser?: UserResponse | undefined;
    createdUserId?: number | undefined;
    isOneTimePinEnabled?:boolean|undefined;
    anonymiseSearchAfterDays?: number | undefined;
      
  }

export class Customer implements ICustomer {
    customerId: number;
    customerName?: string | undefined;
    isCustomerEnabled?: boolean | undefined;
    totalActiveUsers?: number | undefined;
    lastSearchedOn?: Date | undefined;
    trialEndDate?: Date | undefined;
    createdDate?: Date | undefined;
    createdUser?: UserResponse | undefined;
    createdUserId?: number | undefined;
    trialEndDateLocalStr?:string|undefined;
    isOneTimePinEnabled?:boolean|undefined;
    anonymiseSearchAfterDays?: number | undefined;
     
    constructor(data?: ICustomer) {
        if (data) {
          for (var property in data) {
            if (data.hasOwnProperty(property))
              (<any>this)[property] = (<any>data)[property];
          }
        }
      }
      init(_data?: any) {
        if (_data) {
          this.customerId = _data["customerId"];
          this.customerName = _data["customerName"];
          this.isCustomerEnabled = _data["isCustomerEnabled"];
          this.totalActiveUsers = _data["totalActiveUsers"];
          this.lastSearchedOn = _data["lastSearchedOn"] ? new Date(_data["lastSearchedOn"].toString()) : <any>undefined;
          this.trialEndDate = _data["trialEndDate"] ? new Date(_data["trialEndDate"].toString()) : <any>undefined;
          this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
          this.createdUser = _data["createdUser"] ? UserResponse.fromJS(_data["createdUser"]) : <any>undefined;
          this.createdUserId = _data["createdUserId"];
          
          this.trialEndDateLocalStr = _data["trialEndDate"] ? moment(this.trialEndDate).minutes(moment().utcOffset()).minutes(this.trialEndDate.getMinutes()).format("DD/MM/YYYY hh:mm a") : <any>undefined;
         this.isOneTimePinEnabled = _data["isOneTimePinEnabled"];
         this.anonymiseSearchAfterDays = _data["anonymiseAfterDays"];
        
        }
      }
      static fromJS(data: any): Customer {
        data = typeof data === "object" ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
      }
      toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["isCustomerEnabled"] = this.isCustomerEnabled;
        data["totalActiveUsers"] = this.totalActiveUsers;
        data["lastSearchedOn"] = this.lastSearchedOn ? this.lastSearchedOn.toISOString() : <any>undefined;
        data["trialEndDate"] = this.trialEndDate ? this.trialEndDate.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["createdUser"] = this.createdUser ? this.createdUser.toJSON() : <any>undefined;
        data["createdUserId"] = this.createdUserId;
        data["isOneTimePinEnabled"] = this.isOneTimePinEnabled;
       
        return data;
        
      }
  }
  export interface ICustomerForAddEdit {
    
    customerName?: string | undefined;
    isCustomerEnabled?: boolean | undefined;
    trialEndDate?: Date | undefined;
    anonymiseSearchAfterDays?: number | undefined;
    is2FAEnabled?:boolean|undefined;
  }
  
export class CustomerForAddEdit implements ICustomerForAddEdit {
 
  customerName?: string | undefined;
  isCustomerEnabled?: boolean | undefined;
  trialEndDate?: Date | undefined;
  anonymiseSearchAfterDays?: number | undefined;
   is2FAEnabled?:boolean|undefined;
  constructor(data?: ICustomerForAddEdit) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property))
            (<any>this)[property] = (<any>data)[property];
        }
      }
    }
    init(_data?: any) {
      if (_data) {
       
        this.customerName = _data["customerName"];
        this.isCustomerEnabled = _data["isCustomerEnabled"];
        this.trialEndDate = _data["trialEndDate"]? new Date(_data["trialEndDate"].toString()) : <any>undefined;
        this.anonymiseSearchAfterDays =  _data.hasOwnProperty("anonymiseAfterDays") ? _data["anonymiseAfterDays"] : undefined;
        this.is2FAEnabled = _data.hasOwnProperty("is2FAEnabled") ? _data["is2FAEnabled"] : undefined;
      }
    }
    static fromJS(data: any): CustomerForAddEdit {
      data = typeof data === "object" ? data : {};
      let result = new CustomerForAddEdit();
      result.init(data);
      return result;
    }
    toJSON(data?: any) {
      data = typeof data === "object" ? data : {};
     
      data["customerName"] = this.customerName;
      data["isCustomerEnabled"] = this.isCustomerEnabled;
      data["trialEndDate"] = this.trialEndDate ? moment(this.trialEndDate).utc().toISOString(): <any>undefined;
      data["anonymiseAfterDays"] = this.anonymiseSearchAfterDays;
      data["is2FAEnabled"] = this.is2FAEnabled;
   
      return data;
      
    }
}